module.exports = __webpack_public_path__ + "static/media/Priam.25f51390.jpg";